import React from "react";

function TextModal({
  title,
  text,
}) {
  return (
    <section className="container p-5 max-w-md m-auto flex flex-col">
      <h3 className="text-lg leading-tight text-black mb-6 text-bold">
        {title}
      </h3>

      <div className="flex mb-2">
        {
          typeof text === "string"
            ? (
              <p className="text-dark text-md">
                {text}
              </p>
            )
            : text
        }
      </div>
    </section>
  );
}

export default TextModal;
